import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'  // Makes the service available application-wide
})

export class InlineAssessmentService {
 
  private _baseUrl = environment.apiUrl;
  getData: any;
  
  private linkurl = `${environment.apiUrl}/inline_api_request_link`; 
  private responseurl = `${environment.apiUrl}/inline_assessment_api_response`; 
  handleError: (err: any, caught: Observable<any>) => never;
  constructor(private _http: HttpClient) { }
  inlineassessmentService(enable:any): Observable<any[]> {
    const apiurl = `${environment.apiUrl}/inline_api_request?include_archived=${enable}`; 
    console.log("dfgd")
    return this._http.get<any>(apiurl);
  }

 iframelink(requestId: string): Observable<any> {
    return this._http.get<any>(`${this.linkurl}?requestId=${requestId}`);
  } 

}
